import React from 'react';
import { Icon } from 'components/ui';

const MessageBanner = ({ message, state = 'success', setBannerProperties }) => {
  return (
    <div
      className={`NotificationContainer NotificationContainer--${state} mt-0`}
    >
      <div className="NotificationContainer-left mt-0 d-f fd-r ai-c">
        <div>
          <span className="NotificationContainer-icon">
            {state === 'success' ? (
              <Icon name="check_mark" />
            ) : (
              <Icon name="warning_sign" />
            )}
          </span>
        </div>
        <div className="ml-4 mt-8">
          <span className="NotificationContainer-message">{message}</span>
        </div>
      </div>
      <div className="NotificationContainer-right mt-0">
        <button
          type="button"
          className="NotificationContainer-dismissButton"
          onClick={() => {
            setBannerProperties({ message: '', action: 'success' });
          }}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default MessageBanner;
